<template>
  <v-dialog v-model="show" fullscreen  style="z-index:208">
    <v-card>
      <v-card-text class="text-xs-center">
        <h3 class="headline">Upload Answer</h3>
        <br>
        <v-divider></v-divider>
            <v-alert
                :value="true"
                color="info"
                outline
                class="mt-4">
                If you are not able to upload, make sure you have submitted the test succesfully else contact teacher/proctor.
            </v-alert>
        <div v-if="zoomImage">
            <v-img
                :src="zoomImage"
                :lazy-src="zoomImage"
                :aspect-ratio="1"
                contain
                class="grey lighten-2"
                style="max-height: 70vh"></v-img>
            <br>
            <v-btn @click="zoomImage=null" outline round>Close</v-btn>
        </div>

        <v-layout row wrap v-if="uploadState==0" class="mt-2" v-show="!zoomImage">
          <v-flex xs12 md3  >
            <v-card hover class="pa-4" color="primary" dark>
              <v-btn @click="openCamera()" outline round v-if="isDesktop">Take Snapshot</v-btn><b></b>
              <v-btn @click="$refs.file.click()" outline primary round v-if="pdfUpload">Upload File(s)</v-btn>
              <input 
                type="file" ref="file" 
                style="visibility: hidden; width:0; height:0" 
                multiple @change="fileSelected" 
                :accept="user.config.ALLOWED_FILE_UPLOAD?user.config.ALLOWED_FILE_UPLOAD:fileFormats">
            </v-card>
          </v-flex>
          <v-flex xs12 md1></v-flex>
          <v-flex xs12 md6>
            <v-alert :value="emptyFile" color="info" outline icon="info" class="mt-4">
            Uploaded files will be shown here.
            </v-alert>

            <v-layout row wrap v-if="uploadedImages.length">
            <v-flex v-for="(image,i) in uploadedImages" :key="i" xs12 class="pa-1">
              <v-card tile>
                
                <v-card-actions>
                    <v-btn @click="zoomImage = `${config.CDN}test-files/${image}`" round outline >Zoom</v-btn>
                    <v-img :src="`${config.CDN}test-files/${image}`" height="50px" contain></v-img>
                    <v-spacer></v-spacer>
                    <v-btn @click="deleteOverAllFile(i,'image')" round outline color="red">Delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
            </v-layout>

           <v-layout row wrap >
            <v-flex v-for="(pdf,i) in uploadedPdfs" :key="i" xs12 md12 class="pa-1">
              <v-card tile>
                <v-card-actions>
                    <v-btn :href="`${config.CDN}test-files/${pdf}`" target="_blank" round outline >View PDF {{i+1}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="deleteOverAllFile(i,'pdf')" round outline color="red">Delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-flex v-for="(video,i) in uploadedVideos" :key="`v${i}`" xs12 md12 class="pa-1">
              <v-card tile>
                <v-card-actions>
                    <v-btn :href="`${config.CDN}test-files/${video}`" target="_blank" round outline >View Video {{i+1}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="deleteOverAllFile(i,'video')" round outline color="red">Delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-flex v-for="(audio,i) in uploadedAudios" :key="`a${i}`" xs12 md12 class="pa-1">
              <v-card tile>
                <v-card-actions>
                    <v-btn :href="`${config.CDN}test-files/${audio}`" target="_blank" round outline >View Audio {{i+1}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="deleteOverAllFile(i,'audio')" round outline color="red">Delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-flex v-for="(excel,i) in uploadedExcels" :key="`e${i}`" xs12 md12 class="pa-1">
              <v-card tile>
                <v-card-actions>
                    <v-btn :href="`${config.CDN}test-files/${excel}`" target="_blank" round outline >View excel {{i+1}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="deleteOverAllFile(i,'excel')" round outline color="red">Delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>

          </v-layout>
        </v-flex>
        </v-layout>

        <v-layout row wrap v-if="uploadState>=1">
          <v-flex xs12 v-show="uploadState==1">
            
            <div v-if="!cameraError">
               <div class="mt-2">Take picture of your answer sheet</div>
                <br/>
                <video autoplay="true" id="videoElement" ref="videoElement"></video>
                <br/>
                <v-btn btnprimary @click="takepicture()" color="primary" round>Capture</v-btn>
                <v-btn btnprimary @click="uploadState=0" color="secondary" outline round>Cancel</v-btn>
            </div>
            <div v-else>
                <p class="pt-4">Please allow website to access webcam!</p>
                <br>
                <img class="pt-4 pb-4" src="./../../assets/video-permission.png" alt="Allow permission">
                <br>
                <v-btn outline @click="allow()">Recheck</v-btn>
                <v-btn btnprimary @click="uploadState=0" outline>Back</v-btn>
            </div>
            <v-select
                v-if="devices.length>1 && !uploading"
                :items="devices"
                v-model="videoInput"
                item-text="label"
                item-value="deviceId"
                label="Select Camera Device"
                outline
                @change="startWebCam()"
                style="max-width:350px; margin: 0 auto"
            ></v-select>
            <br >
           </v-flex>

        <v-layout v-show="uploadState==2" class="text-xs-center mt-2">
            <v-flex xs12>
                <p>Please make sure your handwriting is visible.</p>
                <canvas id="canvas"></canvas>
                <v-progress-linear :indeterminate="true" v-if="uploading"></v-progress-linear>
                <div>
                    <v-btn @click="uploadBase64()" :disabled="uploading" color="primary" round>Upload</v-btn>
                    <v-btn @click="clearCapture()" :disabled="uploading" color="secondary" round>Retake/Cancel</v-btn>
                </div>
                  <div class="output" style="visibility:hidden;width: 0;height: 0;position:absolute;top:0">
                    <img id="photo" alt="The screen capture will appear in this box.">
                </div>
            </v-flex>
        </v-layout>

        </v-layout>

        <v-layout row wrap v-if="uploadState<=-1">
          <v-layout row wrap class="mt-2">
            <v-flex xs12 class="mt-4" v-for="(sfile, index) in uploadStatuses" :key="index">
                <p class="text-xs-center" v-html="sfile.uploadMessage"></p>
                <v-progress-linear :indeterminate="sfile.indeterminate" :value="sfile.uploadPercent" v-if="uploading"></v-progress-linear>
            </v-flex>
          </v-layout>
        </v-layout>

      </v-card-text>
      <v-card-actions class="mt-4">
        <template v-if="uploadState==0">
          <v-btn color="green darken-1" outline flat @click="$emit('close')"  round>Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="orange" dark  @click="$emit('close')"  round>Done</v-btn>
        </template>
      </v-card-actions>

    </v-card>
   <input style="width:0; height:0; visibility: hidden;position: absolute;top: 0;" type="file" accept="image/*" capture="environment" @change="mobileCamCaptured" ref="mobileCapture" />
  </v-dialog>
</template>

<script>
import {instance as axios} from './../../_axios'
import ReleaseMedia from './../../utils/releaseMedia'
import Compressor from 'compressorjs'
import {mapGetters} from 'vuex'
import getContentType from './../../utils/getContentType'
var gumStream;

const multiplier = 1024*1024
function byteToMB(byte){
    return (byte/multiplier).toFixed(2)
}

axios.timeout = 0

export default {
    data(){
        return {
            uploadState: 0,
            cameraError: false,
            video:  null,
            canvas: null,
            width:  640,
            height: 360,
            devices: [],
            videoInput: null,
            uploading: false,
            base64: null,
            uploadedImages: [],
            selectedImages: [],
            selectedFiles: [],
            uploadedPdfs: [],
            uploadedExcels: [],
            uploadedVideos: [],
            uploadedAudios: [],
            zoomImage: false,
            APPURL: process.env.VUE_APP_URL,
            isDesktop: window.innerWidth>500,
            uploadStatuses: [],
            fileFormats: 'image/*,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/pdf,video/*,audio/*'
        }
    },
    computed:{
        ...mapGetters(['user']),
        emptyFile(){
            return this.uploadedImages.length+this.uploadedPdfs.length+this.uploadedAudios.length+this.uploadedVideos.length+this.uploadedExcels.length==0
        }
    },
    beforeDestroy() {
        ReleaseMedia(gumStream)
    },
    mounted(){
        this.uploadState = 0
        this.cameraError = null
        this.uploadedImages = this.testImages.concat([])
        this.uploadedPdfs = this.pdfFiles || []
        this.uploadedExcels = this.excelFiles || []
        this.uploadedVideos = this.videoFiles || []
        this.uploadedAudios = this.audioFiles || []
        this.getCameraSelection()
        if(window.innerWidth<480){
            this.width = window.innerWidth-30
            this.height = window.innerWidth*4/3
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        testId: {
            type: String,
            default: ''
        },
        testImages: {
            type: Array,
            default: function(){ return [] }
        },
        pdfFiles: {
            type: Array,
            default: function(){ return [] }
        },
        audioFiles: {
            type: Array,
            default: function(){ return [] }
        },
        videoFiles: {
            type: Array,
            default: function(){ return [] }
        },
        excelFiles: {
            type: Array,
            default: function(){ return [] }
        },
        stream: {
            type: MediaStream,
            default: () => null
        },
        pdfUpload: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        openCamera(){
            this.uploadState=1
            if(!this.isDesktop) this.$refs.mobileCapture.click()
        },
        fileSelected(event){
            this.selectedFiles = Array.from(this.$refs.file.files)
            this.uploadState = -1
            this.uploadBulk()
        },
        removeImage(index){
            this.selectedImages.splice(index,1)
            if(this.selectedImages.length<1){
                this.uploadState = 0
            }
        },
        allow(){
            this.$nextTick(() => {
                this.startWebCam()
            })
        },
        async getCameraSelection  ()  {
            const devices = await navigator.mediaDevices.enumerateDevices();
            const videoDevices = devices.filter(device => device.kind === 'videoinput');
            this.devices = videoDevices.map(videoDevice => {
                return { deviceId: videoDevice.deviceId, label: videoDevice.label.charAt(0).toUpperCase()+videoDevice.label.substring(1) }
            });
            // if(videoDevices.length>1) this.devices = [{deviceId: 'user', label: 'Front'}, {deviceId: 'environment', label: 'Rear'}]
        },
        startWebCam(){
           this.video = document.getElementById('videoElement')
            if(this.stream) {
                gumStream = this.stream
                return this.onGettingMediaStream()
            }
            ReleaseMedia(gumStream)
            this.cameraError = null
            if (navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({ 
                    video: {
                        width: 640,
                        height: 480,
                        deviceId: this.videoInput
                    }
                })
                .then( (stream) => {
                    gumStream = stream
                    this.onGettingMediaStream()
                })
                .catch( (err0r) => {
                    if(/permission/.test(err0r.message.toLowerCase())){
                       this.cameraError = "Please allow this website to access webcam!"
                    } else {
                        this.cameraError = err0r.message.replace(/[^\:]*:/, '')
                    }
                });
            }
        },
        onGettingMediaStream(){
            this.video.srcObject = gumStream;
            this.video.play()
            this.video.addEventListener('canplay', (ev) => {
                this.height = this.video.videoHeight / (this.video.videoWidth/this.width);
            })
        },
        takepicture() {
            var canvas = document.getElementById('canvas')
            var context = canvas.getContext('2d');
            if (this.width && this.height) {
                this.uploadState = 2
                canvas.width = this.width;
                canvas.height = this.height;
                context.drawImage(this.video, 0, 0, this.width, this.height);
                
                var data = canvas.toDataURL('image/png');
                photo.setAttribute('src', data);
                this.base64 = data
            } else {
                this.clearphoto();
            }
        },
        clearphoto() {
            var canvas = document.getElementById('canvas')
            var context = canvas.getContext('2d');
            context.fillStyle = "#AAA";
            context.fillRect(0, 0, canvas.width, canvas.height);
            var data = canvas.toDataURL('image/png');
            photo.setAttribute('src', data);
        },
        clearCapture(){
            this.clearphoto()
            this.uploadState = 1
        },
        uploadBase64(){
            this.uploading = true
            var qn = -1
            document.getElementById('canvas').toBlob((file => {
                var fd = new FormData();
                fd.append('test_id', String(this.testID));
                fd.append('content_type', 'image/png');
                if(this.config.BUCKET) fd.append('bucket', this.config.BUCKET);
                
                return axios.post(`/presignURL/${this.testId}/${qn}/png`, fd)
                    .then(resp => {
                        fd.append('fileName', resp.data.fileName)
                        var options = {
                            headers: {
                                'Content-Type': 'image/png',
                                'x-amz-acl': 'public-read'
                            }
                        };
                        return axios.put(resp.data.signedURL, file, options)
                    })
                    .then(resp => {
                        return axios.post(`/savePresignedURL/${this.testId}/${qn}/png`, fd)
                    })
                    .then(resp => {
                        this.uploadState = 0
                        this.uploadedImages = resp.data.newData
                        this.$emit('fileUploaded', { data: this.uploadedImages, type: 'image'})
                        return { success: true, newData: resp.data.newData }
                    })
                    .catch(error => {
                        console.log(error)
                        this.$store.commit('open_snackbar', {text: 'File upload failed. Please try again.', color: 'red'})
                        return { success: false, error }
                    })
                    .finally(() => {
                        this.uploading = false
                    })
            }), 'image/webp')
                 
        },
        uploadBulk(){
            this.uploadStatuses = []
            var promises = this.selectedFiles.map(async (file, index) => {
                this.uploading = true
                this.uploadStatuses.push({
                    uplaodPercent: 0,
                    uploadMessage: `Uploading <b>${file.name}</b>...`
                })
                var qn = 0
                var fd = new FormData()
                var extension = file.name.substring(file.name.lastIndexOf('.')+1)
                fd.append('test_id', String(this.testId));
                fd.append('content_type', file.type)
                if(this.config.BUCKET) fd.append('bucket', this.config.BUCKET);
                
                let contentType = file.type
                if(contentType.startsWith('image/')){
                    file = await getCompressed(file)
                }
                var options = {
                    headers: {
                        'Content-Type': contentType, //getContentType(fileType),
                        'x-amz-acl': 'public-read'
                    },
                    onUploadProgress: progressEvent => {
                        this.uploadStatuses[index].uploadPercent = progressEvent.loaded*100/(file.size || 1)
                        this.uploadStatuses[index].uploadMessage = `Uploading <b>${file.name}</b>...  ${this.uploadStatuses[index].uploadPercent.toFixed(2)}% (${byteToMB(progressEvent.loaded)}/${byteToMB(file.size)} MB)`
                    }
                };
                return axios.post(`/presignURL/${this.testId}/${qn}/${extension}`, fd)
                    .then(resp => {
                        fd.append('fileName', resp.data.fileName)
                        return axios.put(resp.data.signedURL, file, options)
                    })
                    .then(resp => {
                        return axios.post(`/savePresignedURL/${this.testId}/${qn}/${extension}`, fd)
                    })
                    .then(resp => {
                        this.$emit('fileUploaded', { data: resp.data.newData, type: contentTypeToKey(contentType) })
                        this.$store.commit('open_snackbar', { text: 'File Upload Successfull.', color: 'green' })
                        if(contentType.startsWith('image/')) this.uploadedImages = Array.from(new Set(resp.data.newData))
                        else if(contentType.startsWith('application/pdf')) this.uploadedPdfs = Array.from(new Set(resp.data.newData))
                        else if(contentType.startsWith('video')) this.uploadedVideos = Array.from(new Set(resp.data.newData))
                        else if(contentType.startsWith('audio')) this.uploadedAudios = Array.from(new Set(resp.data.newData))
                        else if(contentType.startsWith('application/vnd')) this.uploadedExcels = Array.from(new Set(resp.data.newData))
                        else {
                            console.error('Unknown File Type')
                        }
                        return { success: true, newData: resp.data.newData, type: contentType }
                    })
                    .catch(error => {
                        this.$store.commit('open_snackbar', {text: 'File upload failed. Please try again.', color: 'red'})
                        return { success: false, error }
                    })
            })
            
            Promise.all(promises)
            .then(values => {
                this.uploading = false
                var files = values.filter((val, index) => val.success == true)
                this.selectedFiles = this.selectedFiles.filter((val, index) => values[index].success == false)
            })
            .catch(error => {
                this.$store.commit('open_snackbar', {text: 'Upload failed! Please try again', color: 'red'}) 
            })
            .finally(() => {
                this.uploadState = 0
                this.uploading = false
            })
            
        },
        closeCamera(){
           ReleaseMedia(gumStream)
        },
        deleteOverAllFile(i, type){
            this.uploading   = true
            this.uploadState = -1
            const file_name  = getFilename(this, i, type)// type=='png'?this.uploadedImages[i]:this.uploadedPdfs[i]
            this.uploadStatuses = [
                {
                    uploadPercent: 100,
                    indeterminate: true,
                    uploadMessage: 'Deleting please wait...'
                }
            ]

            axios.post('/deleteOverAllFile', {test_id: this.testId, file_name, type})
           .then(resp => {
                updateData(this, i, type)
            })
           .catch(error => {
                this.$store.commit('open_snackbar', {text: 'Delete failed! Please try again', color: 'red'}) 
           })
           .then(() => {
                this.uploading = false
                this.uploadState = 0 
           })
        },
        mobileCamCaptured(event){
            
            this.uploading = true
            let files = event.target.files
            if(files.length<1) return 

            this.uploadState = 2
            let fileReader   = new FileReader()
            fileReader.onload = (prog) => {
                var image = new Image()
                image.onload = () => {
                    var canvas  = document.getElementById('canvas')
                    var context = canvas.getContext('2d')
                    context.drawImage(image, 0, 0, this.width, this.height)
                }
                image.src = prog.target.result
                console.log(prog)
            }

            fileReader.readAsDataURL(files[0])
            
            var qn = 0
            var fd = new FormData()                
            fd.append('test_id', String(this.testId));
            if(this.config.BUCKET) fd.append('bucket', this.config.BUCKET);

            let that = this
             
            new Compressor(files[0], {
                quality: 0.8,
                maxWidth: 1080,
                maxHeight: 720,
                success(result) {

                 axios.post(`/presignURL/${that.testId}/${qn}/png`, fd)
                    .then(resp => {
                        fd.append('fileName', resp.data.fileName)
                        var options = {
                            headers: {
                                'Content-Type': getContentType('png'),
                                'x-amz-acl': 'public-read'
                            }
                        };
                        return axios.put(resp.data.signedURL, file, options)
                    })
                    .then(resp => {
                        return axios.post(`/savePresignedURL/${that.testId}/${qn}/png`, fd)
                    })
                    .then(resp => {
                        that.uploadedImages = resp.data.newData
                        that.$emit('fileUploaded', { data: resp.data.newData, type: 'png'})
                        return { success: true, newData: resp.data.newData }
                    })
                    .catch(error => {
                        console.log(error)
                        that.$store.commit('open_snackbar', {text: 'Image upload failed. Please try again.', color: 'red'})
                        return { success: false, error }
                    })
                    .finally(() => {
                        that.uploadState = 0
                        that.uploading = false
                    })
                },
                error(err) {
                    console.log(err.message);
                },
            });
            
        }
    },
    watch:{
        uploadState(val, oldval){
            if(val==0){
                this.cameraError = null
            } else if(val==1)
            this.$nextTick(() => {
                this.startWebCam()
            })
        }
    }
}

function getCompressed(file){
   return new Promise((resolve, reject) => {
        new Compressor(file, {
                quality: 0.8,
                maxWidth: 1080,
                maxHeight: 720,
                success(result) {
                    resolve(result)
                },
                error(err) {
                    console.log(err.message);
                    reject(err)
                }
            })
   })
}

function getFilename(context, i , type){
    switch (type) {
        case 'pdf':
            return context.uploadedPdfs[i]
        case 'audio':
            return context.uploadedAudios[i]
        case 'excel':
            return context.uploadedExcels[i]
        case 'video':
            return context.uploadedVideos[i]
        case 'image':
            return context.uploadedImages[i]
        default:
            break;
    }
}

function updateData(context, i , type){
    context.$store.commit('open_snackbar', { text: 'File deleted!', color: 'green' })
    switch (type) {
        case 'pdf':
            context.$emit('fileUploaded', { data: context.uploadedPdfs, type: typeToKey(type) })
            return context.uploadedPdfs.splice(i,1)
        case 'audio':
            context.$emit('fileUploaded', { data: context.uploadedAudios, type: typeToKey(type) })
            return context.uploadedAudios.splice(i,1)
        case 'excel':
            context.$emit('fileUploaded', { data: context.uploadedExcels, type: typeToKey(type) })
            return context.uploadedExcels.splice(i,1)
        case 'video':
            context.$emit('fileUploaded', { data: context.uploadedVideos, type: typeToKey(type) })
            return context.uploadedVideos.splice(i,1)
        case 'image':
            context.$emit('fileUploaded', { data: context.uploadedImages, type: typeToKey(type) })
            return context.uploadedImages.splice(i,1)
        default:
            break;
    }
}

function typeToKey(type){
    switch (type) {
        case 'pdf': return 'pu'
        case 'audio': return 'au'
        case 'excel': return 'eu'
        case 'video': return 'vu'
        case 'image': return 'iu'
    }
    return 'unknown'
}

function contentTypeToKey(contentType){
    if(contentType.startsWith('image/')) return 'iu'
    else if(contentType.startsWith('application/pdf')) return 'pu'
    else if(contentType.startsWith('video')) return 'vu'
    else if(contentType.startsWith('audio')) return 'au'
    else if(contentType.startsWith('application/vnd')) return 'eu'
    else {
        console.error('Unknown File Type')
    }
}
</script>

<style>
#videoElement {
	max-width: 100%;
	height: auto;
	background-color: #666;
}
</style>